import request from '@/utils/request'
import { apiUrl } from './config'

type dataType = any
export default {
  getSituation(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: apiUrl + '/rjhy-fundflow/api/1/chip/pro/situation',
      method: 'get',
      params: data,
      headers: {
        appCode: 'com.rjhy.uranus',
        token: data.token
      },
      sign: true
    })
  },
  getJzd(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: apiUrl + '/rjhy-fundflow/api/1/chip/pro/jzd',
      method: 'get',
      params: data,
      headers: {
        appCode: 'com.rjhy.uranus',
        token: data.token
      },
      sign: true
    })
  }
}
